import { Button, Result } from 'antd';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const OwnNotFound = ({t}) => {
    const navigate = useNavigate();
  return (
    <div className="not-found"
        style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '78vh',
        }}
    >

    <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={<Button type="primary"
        onClick={() => navigate('/')}
        >Back Home</Button>}
        />
    </div>
  );
}

export default OwnNotFound